export default {
  GeneralVoucherList: {
    TitleName: 'Chứng từ nghiệp vụ khác',
    TitleParallelVoucher: 'Chứng từ ghi đồng thời',
    Object: 'Đối tượng',
  },

  VoucherList: {
    TitleName: 'Bảng tổng hợp chứng từ cùng loại',
  },
  VoucherListDetail: {
    TitleName: 'Tổng hợp chứng từ cùng loại',
    SumLabel: 'Tổng tiền',
    TitleGroup: 'Thông tin chung',
    RefNo: 'Số',
    RefDate: 'Ngày',
  },

  VoucherListPopup: {
    TitleName: 'Chọn chứng từ',
    SummaryText: 'Số tiền được chọn/Tổng số tiền',
  },

  RegisterList: {
    TitleName: 'Chứng từ ghi sổ',
  },
  RegisterListDetail: {
    TitleName: 'Chứng từ ghi sổ',
    SumLabel: 'Tổng tiền',
    TitleGroup: 'Thông tin chung',
    RefNo: 'Số',
    RefDate: 'Ngày',
  },
  RegisterListPopup: {
    TitleName: 'Chọn chứng từ',
    DatePeriod: 'Khoảng thời gian',
    FromDate: 'Từ',
    ToDate: 'Đến',
  },
};
